<template>
    <div class="title contain_main">
        {{title}}
    </div>
</template>
<script>
export default {
    name:"Title",
    props:['title'],
    data(){
        return{}
    }
}
</script>
<style lang="css" scoped>
    .title{
        margin-top: 0.30rem;
        font-size: 0.24rem;
        color: #464646;
        line-height: 0.30rem;
        text-align:left;
    }
</style>


// WEBPACK FOOTER //
// src/components/title.vue